import EntityPage from '../EntityPage/EntityPage';

const Cryptocurrency = () => {
    return <EntityPage entityType="Cryptocurrency" />;
};

export default Cryptocurrency;
